import { render, staticRenderFns } from "./RecipientStickySummary.vue?vue&type=template&id=1e23055b&"
import script from "./RecipientStickySummary.vue?vue&type=script&lang=ts&"
export * from "./RecipientStickySummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../_locales/Organs.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Frecipients%2FRecipientStickySummary.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/components/recipients/_locales/RecipientStickySummary.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Frecipients%2FRecipientStickySummary.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports